import $ from '@rover/globals/jquery';

const ScrollTrigger = (instanceOptions, callback) => {
  /**
   * Triggers callback when `instanceOptions.$element` is at least `offset`
   * pixels above the bottom of the viewport.
   *
   * @type {{$element: jQuery element, offset: number}}
   */
  const defaultOptions = {
    $element: null,
    offset: 50,
  };
  const options = Object.assign({}, defaultOptions, instanceOptions);
  const $window = $(window);

  const scrollHandler = () => {
    const viewportBottom = $window.scrollTop() + $window.height();
    const triggerHeight = options.$element.offset().top + 50;
    if (viewportBottom >= triggerHeight) {
      callback(options.$element);
      $window.off('scroll', scrollHandler);
    }
  };

  $window.on('scroll', scrollHandler);
};

export default ScrollTrigger;



// WEBPACK FOOTER //
// ../utilities/scroll.js